
<html>
  <h1> Encuestas disponibles </h1>
 <div  *ngFor="let encuesta of listadeencuestaslibres let i = index" >
  <li>
    <a  aria-current="page" href="/encuestas/{{encuesta.encuesta_id}}" >{{encuesta.nombre}}</a>
  </li>
 </div>
</html>
